import { render, staticRenderFns } from "./TeamRatings.vue?vue&type=template&id=4e92dacc&scoped=true"
import script from "./TeamRatings.vue?vue&type=script&lang=js"
export * from "./TeamRatings.vue?vue&type=script&lang=js"
import style0 from "./TeamRatings.vue?vue&type=style&index=0&id=4e92dacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e92dacc",
  null
  
)

export default component.exports